import React from 'react';
import CompanyAddressForm from 'shared/components/Forms/CompanyAddressForm';
import SignupContainer from 'views/SignupContainer';

const CompanyAddress: React.FC = () => {
  return (
    <SignupContainer>
      <CompanyAddressForm />
    </SignupContainer>
  );
};

export default CompanyAddress;
